import { combineReducers } from "redux";
import { supportData } from "./reducer";

export default combineReducers({ supportData });
